var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isUnsupportedPage } from 'utils/checkUrl';
import { getDevice, isWebview, versionEnough } from 'utils/isWebView';
import axios from 'axios';
// trueがアプリUPDATEを促す
export default () => __awaiter(void 0, void 0, void 0, function* () {
    if (!isWebview() || isUnsupportedPage()) {
        return false;
    }
    const isDevEnv = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local';
    if (isDevEnv) {
        return false;
    }
    const path = isDevEnv ? 'https://sail-app-versions.s3.ap-northeast-1.amazonaws.com/dev-info.json' : 'https://sail-app-versions.s3.ap-northeast-1.amazonaws.com/info.json';
    const timestamp = new Date().getTime();
    return axios
        .get(path + '?q=' + timestamp)
        .then((response) => {
        const version = response.data[getDevice()];
        if (version && !versionEnough('webview', version)) {
            return true;
        }
        return false;
    })
        .catch((_) => {
        return false;
    });
});
